import { getCurrentLanguage } from '../i18n';

export const mask = (v: string) => {
  v = v.replace(/\D/g, '');

  if (v.length <= 11) {
    v = v.replace(/(\d{3})(\d)/, '$1.$2');
    v = v.replace(/(\d{3})(\d)/, '$1.$2');
    v = v.replace(/(\d{3})(\d{1,2})$/, '$1-$2');
  } else {
    v = v.replace(/^(\d{2})(\d)/, '$1.$2');
    v = v.replace(/^(\d{2})\.(\d{3})(\d)/, '$1.$2.$3');
    v = v.replace(/\.(\d{3})(\d)/, '.$1/$2');
    v = v.replace(/(\d{4})(\d)/, '$1-$2');
  }

  return v;
};

export const cellPhoneMask = (v: any) => {
  let r = v.replace(/\D/g, '');
  r = r.replace(/^0/, '');

  if (r.length > 11) {
    r = r.replace(/^(\d\d)(\d{5})(\d{4}).*/, '($1) $2-$3');
  } else if (r.length > 7) {
    r = r.replace(/^(\d\d)(\d{5})(\d{0,4}).*/, '($1) $2-$3');
  } else if (r.length > 2) {
    r = r.replace(/^(\d\d)(\d{0,5})/, '($1) $2');
  } else if (v.trim() !== '') {
    r = r.replace(/^(\d*)/, '($1');
  }
  return r;
};

export const phoneMask = (v: any) => {
  let r = v.replace(/\D/g, '');
  r = r.replace(/^0/, '');

  if (r.length > 11) {
    r = r.replace(/^(\d\d)(\d{4})(\d{4}).*/, '($1) $2-$3');
  } else if (r.length > 7) {
    r = r.replace(/^(\d\d)(\d{4})(\d{0,4}).*/, '($1) $2-$3');
  } else if (r.length > 2) {
    r = r.replace(/^(\d\d)(\d{0,4})/, '($1) $2');
  } else if (v.trim() !== '') {
    r = r.replace(/^(\d*)/, '($1');
  }
  return r;
};

export const currency = (value: string | number) => {
  const v = typeof value === 'string' ? parseFloat(value) : (value ?? 0);
  return v.toLocaleString(getCurrentLanguage(), {
    style: 'currency',
    currency: 'BRL',
  });
};

export const getDateExtensive = () => {
  return new Intl.DateTimeFormat(getCurrentLanguage(), {
    day: 'numeric',
    month: 'long',
    year: 'numeric',
  }).format(new Date());
};

export const validateCpfCnpj = (value: string | undefined) => {
  if (!value) return false;
  value = value.replace(/[^\d]+/g, '');
  return value.length === 11 ? validateCPF(value) : validateCNPJ(value);
};

const validateCPF = (value: string) => {
  let sum = 0;
  let rest = null;
  if (value == '00000000000') return false;

  for (let i = 1; i <= 9; i++)
    sum = sum + parseInt(value?.substring(i - 1, i)) * (11 - i);
  rest = (sum * 10) % 11;

  if (rest == 10 || rest == 11) rest = 0;
  if (rest != parseInt(value?.substring(9, 10))) return false;

  sum = 0;
  for (let i = 1; i <= 10; i++)
    sum = sum + parseInt(value?.substring(i - 1, i)) * (12 - i);
  rest = (sum * 10) % 11;

  if (rest == 10 || rest == 11) rest = 0;
  if (rest != parseInt(value?.substring(10, 11))) return false;
  return true;
};

const validateCNPJ = (CNPJ: string) => {
  const a: any[] = [];
  let b = 0;
  let x, y;
  const c = [6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];
  for (let i = 0; i < 12; i++) {
    a[i] = CNPJ.charAt(i);
    b += a[i] * c[i + 1];
  }
  if ((x = b % 11) < 2) {
    a[12] = 0;
  } else {
    a[12] = 11 - x;
  }
  b = 0;
  for (y = 0; y < 13; y++) {
    b += a[y] * c[y];
  }
  if ((x = b % 11) < 2) {
    a[13] = 0;
  } else {
    a[13] = 11 - x;
  }
  if (CNPJ.charAt(12) != a[12] || CNPJ.charAt(13) != a[13]) {
    return false;
  }
  if (CNPJ == '00000000000000') {
    return false;
  }
  return true;
};

export const validateDateFutureOrNot = (date: string | undefined) => {
  if (!date) return false;
  const d = date.split('-');
  const dateConsult = new Date(+d[0], +d[1] - 1, +d[2]);
  const today = new Date();
  if (dateConsult <= today) {
    return true;
  }
  return false;
};

export const convertToLowerCase = (value: string | undefined) => {
  const text = value?.toLowerCase().replace(/(?:^|\s)\S/g, function (a) {
    return a.toUpperCase();
  });
  return text;
};

export const groupBy = (items: any[], key: string) =>
  items.reduce(
    (result, item) => ({
      ...result,
      [item[key]]: [...(result[item[key]] || []), item],
    }),
    {},
  );

export const formatToBRL = (value: any) => {
  if (typeof value !== 'number' || isNaN(value)) {
    return '';
  }

  return new Intl.NumberFormat(getCurrentLanguage(), {
    style: 'currency',
    currency: 'BRL',
    minimumFractionDigits: 2,
  }).format(value);
};

export const parseCurrencyInput = (
  inputValue: string | number | undefined | null,
): number => {
  if (inputValue === null || inputValue === undefined || inputValue === '') {
    return 0;
  }

  const inputString = String(inputValue);
  const digitsOnly = inputString.replace(/[^\d]/g, '');

  if (digitsOnly === '') {
    return 0;
  }

  const cents = parseInt(digitsOnly, 10);
  return cents / 100;
};
